import { resolveTabIn, searchWithTabFor } from '../../util_components/page_tabs/page_tabs';
import type { TabDef as GenericTabDef } from '../../util_components/page_tabs/page_tabs';
import { ADVISOR_URL_PARAMS } from './advisors/advisors';

export type PageTab = 'tasks' | 'generation' | 'report' | 'sales_users' | 'advisors';

export type TabDef = GenericTabDef<PageTab>;

export const DEFAULT_TAB: PageTab = 'tasks';

const MANAGER_TABS: PageTab[] = ['sales_users', 'advisors'];

const ALL_TABS: TabDef[] = [
  { id: 'tasks', label: 'Tasks' },
  { id: 'generation', label: 'Task generation' },
  { id: 'report', label: 'Instant task report' },
  { id: 'sales_users', label: 'Sales users' },
  { id: 'advisors', label: 'Advisors' }
];

// The report tab is SUPER_USER-only; the sales-users and advisors tabs are for
// SUPER_USER or sales team managers. They are absent (not disabled) otherwise.
export const tabList = (canViewReport: boolean, canManageSalesUsers = false): TabDef[] =>
  ALL_TABS.filter(
    (t) =>
      (t.id !== 'report' || canViewReport) && (!MANAGER_TABS.includes(t.id) || canManageSalesUsers)
  );

export const resolveTab = (
  search: string | URLSearchParams,
  canViewReport: boolean,
  canManageSalesUsers = false
): PageTab => resolveTabIn(tabList(canViewReport, canManageSalesUsers), DEFAULT_TAB, search);

// The advisor/view/from/to deep-link params only mean something on the advisors tab.
export const searchWithTab = (search: string | URLSearchParams, tab: PageTab): string => {
  const params = new URLSearchParams(typeof search === 'string' ? search : search.toString());
  if (tab !== 'advisors') ADVISOR_URL_PARAMS.forEach((k) => params.delete(k));
  return searchWithTabFor(DEFAULT_TAB, params, tab);
};
